import $ from 'jquery';
import whatInput from 'what-input';

window.$ = $;

import Foundation from 'foundation-sites';
// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
//import './lib/foundation-explicit-pieces';

$(document).foundation();

// forEach EI polyfill

// Function to make IE9+ support forEach:
(function() {
    if (typeof NodeList.prototype.forEach === "function")
        return false;
    else
        NodeList.prototype.forEach = Array.prototype.forEach;
})();

// sprawdzenie jezyka
function checkLang () {
    const htmlLang = document.documentElement.lang;
    return htmlLang;
}

// mapka

var map = null;
var markers = [];
var all_markers = [];
var markerCluster = null;
var zurla = true;
var count;


function initMap() {

    const mapDataLang = {
        pl: {
            start: {
                zoom: 11, minZoom: 7, center: new google.maps.LatLng(52.2, 21), // PL
                styles: [
                    {"elementType": "geometry", "stylers": [{"color": "#f5f5f5"}]},
                    {"elementType": "labels.icon", "stylers": [{"visibility": "off"}]},
                    {"elementType": "labels.text.fill", "stylers": [{"color": "#616161"}]},
                    {"elementType": "labels.text.stroke", "stylers": [{"color": "#f5f5f5"}]},
                    {"featureType": "administrative.land_parcel", "elementType": "labels.text.fill", "stylers": [{"color": "#bdbdbd"}]},
                    {"featureType": "poi", "elementType": "geometry", "stylers": [{"color": "#eeeeee"}]},
                    {"featureType": "poi", "elementType": "labels.text.fill", "stylers": [{"color": "#757575"}]},
                    {"featureType": "poi.park", "elementType": "geometry", "stylers": [{"color": "#e5e5e5"}]},
                    {"featureType": "poi.park", "elementType": "labels.text.fill", "stylers": [{"color": "#9e9e9e"}]},
                    {"featureType": "road", "elementType": "geometry", "stylers": [{"color": "#ffffff"}]},
                    {"featureType": "road.arterial", "elementType": "labels.text.fill", "stylers": [{"color": "#757575"}]},
                    {"featureType": "road.highway", "elementType": "geometry", "stylers": [{"color": "#dadada"}]},
                    {"featureType": "road.highway", "elementType": "labels.text.fill", "stylers": [{"color": "#616161"}]},
                    {"featureType": "road.local", "elementType": "labels.text.fill", "stylers": [{"color": "#9e9e9e"}]},
                    {"featureType": "transit.line", "elementType": "geometry", "stylers": [{"color": "#e5e5e5"}]},
                    {"featureType": "transit.station", "elementType": "geometry", "stylers": [{"color": "#eeeeee"}]},
                    {"featureType": "water", "elementType": "geometry", "stylers": [{"color": "#c9c9c9"}]},
                    {"featureType": "water", "elementType": "labels.text.fill", "stylers": [{"color": "#9e9e9e"}]}
                ],
                disableDefaultUI: true,
                zoomControl: true,
                zoomControlOptions: {
                    position: google.maps.ControlPosition.RIGHT_TOP
                },
                scrollwheel: false
            },
            geo: 'https://www.myfirststop.pl/api/geo_mfs_pl.js',
            closeText: 'ZAMKNIĘTE',
            openText: 'Godziny otwarcia',
            pnptText: 'pon.-pt.',
            satText: 'sob.',
            sunText: 'niedz.',
            routeText: 'Wyznacz trasę',
            phoneText: 'Zadzwoń',
            emailText: 'Napisz do nas',
            jobOffer: 'ZOBACZ OFERTĘ',
            mechanikText: 'Mechanik',
            wulkanizatorText: 'Wulkanizator',
            doradcaText: 'Doradca Klienta'

        },
        cz: {
            start: {
                zoom: 8, minZoom: 6, center: new google.maps.LatLng(50.0719267,14.4697382),   // CZ
                styles: [
                    {"elementType": "geometry", "stylers": [{"color": "#f5f5f5"}]},
                    {"elementType": "labels.icon", "stylers": [{"visibility": "off"}]},
                    {"elementType": "labels.text.fill", "stylers": [{"color": "#616161"}]},
                    {"elementType": "labels.text.stroke", "stylers": [{"color": "#f5f5f5"}]},
                    {"featureType": "administrative.land_parcel", "elementType": "labels.text.fill", "stylers": [{"color": "#bdbdbd"}]},
                    {"featureType": "poi", "elementType": "geometry", "stylers": [{"color": "#eeeeee"}]},
                    {"featureType": "poi", "elementType": "labels.text.fill", "stylers": [{"color": "#757575"}]},
                    {"featureType": "poi.park", "elementType": "geometry", "stylers": [{"color": "#e5e5e5"}]},
                    {"featureType": "poi.park", "elementType": "labels.text.fill", "stylers": [{"color": "#9e9e9e"}]},
                    {"featureType": "road", "elementType": "geometry", "stylers": [{"color": "#ffffff"}]},
                    {"featureType": "road.arterial", "elementType": "labels.text.fill", "stylers": [{"color": "#757575"}]},
                    {"featureType": "road.highway", "elementType": "geometry", "stylers": [{"color": "#dadada"}]},
                    {"featureType": "road.highway", "elementType": "labels.text.fill", "stylers": [{"color": "#616161"}]},
                    {"featureType": "road.local", "elementType": "labels.text.fill", "stylers": [{"color": "#9e9e9e"}]},
                    {"featureType": "transit.line", "elementType": "geometry", "stylers": [{"color": "#e5e5e5"}]},
                    {"featureType": "transit.station", "elementType": "geometry", "stylers": [{"color": "#eeeeee"}]},
                    {"featureType": "water", "elementType": "geometry", "stylers": [{"color": "#c9c9c9"}]},
                    {"featureType": "water", "elementType": "labels.text.fill", "stylers": [{"color": "#9e9e9e"}]}
                ],
                disableDefaultUI: true,
                zoomControl: true,
                zoomControlOptions: {
                    position: google.maps.ControlPosition.RIGHT_TOP
                },
                scrollwheel: false
            },
            geo: 'https://www.myfirststop.cz/api/geo_mfs_cz-jobs.js',
            closeText: 'ZAVŘENO',
            openText: 'Otevírací doba',
            pnptText: 'Po-Pá',
            satText: 'Sob',
            sunText: 'Ned',
            routeText: 'Vypočtěte trasu',
            phoneText: 'Telefon',
            emailText: 'Poslat Email',
            jobOffer: 'ZOBRAZ NABÍDKY',
            mechanikText: 'Mechanik',
            wulkanizatorText: 'Montér pneumatik',
            doradcaText: 'Zákaznický servis'
        },
        hu: {
            start: {
                zoom: 8, minZoom: 6, center: new google.maps.LatLng(47.535, 19.1),
                styles: [
                    { "elementType": "geometry", "stylers": [{ "color": "#f5f5f5"}]},
                    { "elementType": "labels.icon", "stylers": [{ "visibility": "off" }]},
                    { "elementType": "labels.text.fill", "stylers": [{ "color": "#616161" }]},
                    { "elementType": "labels.text.stroke", "stylers": [{ "color": "#f5f5f5"}]},
                    { "featureType": "administrative.land_parcel", "elementType": "labels.text.fill", "stylers": [{"color": "#bdbdbd"}]},
                    { "featureType": "poi", "elementType": "geometry", "stylers": [{ "color": "#eeeeee"}]},
                    { "featureType": "poi", "elementType": "labels.text.fill", "stylers": [{ "color": "#757575" }]},
                    { "featureType": "poi.park", "elementType": "geometry", "stylers": [{ "color": "#e5e5e5" }]},
                    { "featureType": "poi.park", "elementType": "labels.text.fill", "stylers": [{ "color": "#9e9e9e" }]},
                    { "featureType": "road", "elementType": "geometry", "stylers": [{ "color": "#ffffff" }]},
                    { "featureType": "road.arterial", "elementType": "labels.text.fill", "stylers": [{ "color": "#757575" }]},
                    { "featureType": "road.highway", "elementType": "geometry", "stylers": [{ "color": "#dadada" }]},
                    { "featureType": "road.highway", "elementType": "labels.text.fill", "stylers": [{ "color": "#616161" }]},
                    { "featureType": "road.local", "elementType": "labels.text.fill", "stylers": [{ "color": "#9e9e9e" }]},
                    { "featureType": "transit.line", "elementType": "geometry", "stylers": [{ "color": "#e5e5e5" }]},
                    { "featureType": "transit.station", "elementType": "geometry", "stylers": [{ "color": "#eeeeee" }]},
                    { "featureType": "water", "elementType": "geometry", "stylers": [{ "color": "#c9c9c9" }]},
                    { "featureType": "water", "elementType": "labels.text.fill", "stylers": [{ "color": "#9e9e9e" }]}
                ],
                disableDefaultUI: true,
                zoomControl: true,
                zoomControlOptions: { position: google.maps.ControlPosition.RIGHT_TOP },
                scrollwheel: false
            },
            geo: 'https://www.myfirststop.hu/api/geo_mfs_hu-jobs.js',
            closeText: 'ZÁRVA',
            openText: 'NYITVA ',
            pnptText: 'pon.-pt.',
            satText: 'sob.',
            sunText: 'niedz.',
            routeText: 'Útvonaltervező',
            phoneText: 'Hívás',
            emailText: 'Írj nekünk',
            jobOffer: 'JELENTKEZEM',
            mechanikText: 'Autószerelő',
            wulkanizatorText: 'Gumiszerelő',
            doradcaText: 'Vevőszolgálati tanácsadó'
        }
    };

    let mapData;

    if ( checkLang() === 'pl') {
        mapData = mapDataLang.pl;
    }

    if ( checkLang() === 'cz') {
        mapData = mapDataLang.cz;
    }

    if ( checkLang() === 'hu') {
        mapData = mapDataLang.hu;
    }



    $("#map").fadeTo(0, 0);
    map = new google.maps.Map(document.getElementById('map'), mapData.start);

    var input = document.getElementById('searchinput');
    var searchBox = new google.maps.places.SearchBox(input);

    $('#searchinput').closest('form').submit(function (e) {
        e.preventDefault();
        input.focus();
        google.maps.event.trigger(input, 'keydown', {keyCode: 13});
        searchResultsSection.slideDown(500)
    });

    map.addListener('bounds_changed', function () {
        searchBox.setBounds(map.getBounds());
    });

    searchBox.addListener('places_changed', function () {
        var places = searchBox.getPlaces();

        if (places.length == 0) {
            return;
        }

        var bounds = new google.maps.LatLngBounds();

        places.forEach(function (place) {
            if (!place.geometry) {
                console.log("Returned place contains no geometry");
                return;
            }
            if (place.geometry.viewport) {
                bounds.union(place.geometry.viewport);
            } else {
                bounds.extend(place.geometry.location);
            }
        });
        map.fitBounds(bounds);
    });

    var script = document.createElement('script');
    script.src = mapData.geo;
    // 'https://www.myfirststop.pl/api/geo_mfs_pl.js';
    // script.src = 'assets/geo/geo_mfs_pl.js';
    // script.src = 'assets/geo/geo_mfs_cz.js';
    // script.src = 'assets/geo/geo_mfs_sk.js';
    // script.src = 'assets/geo/geo_mfs_hu.js';
    // script.src = 'assets/geo/geo_lv-20180607.js';
    // script.src = 'assets/geo/geo_ee-20180607.js';

    document.getElementsByTagName('head')[0].appendChild(script);

    function isLinkExpiryDateWithinRange(monfri, sat) {

        var now = new Date();
        var day = now.getDay();
        var value = '';

        switch (day) {
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                if (!monfri) return '';
                value = monfri.split(/[-:]/);
                break;
            case 6:
                if (!sat) return '';
                value = sat.split(/[-:]/);
                break;
            default:
                return mapData.closeText;
                // return 'ZAMKNIĘTE';
            // return 'ZAVŘENO';
            // return 'ZÁRVA';
        }

        if ((parseInt(now.getHours()) > parseInt(value[0]) || parseInt(now.getHours()) == parseInt(value[0]) && parseInt(now.getMinutes()) >= parseInt(value[1])) && (parseInt(now.getHours()) < parseInt(value[2]) || parseInt(now.getHours()) == parseInt(value[2]) && parseInt(now.getMinutes()) <= parseInt(value[3])))
            return '<span style="color: #3bb311">'+ mapData.openText + ' ' +value[2] + ':' + value[3] + '</span>';
        // return '<span style="color: #3bb311">OTEVŘENO DO ' + value[2] + ':' + value[3] + '</span>';
        // return '<span style="color: #3bb311">NYITOTT ' + value[2] + ':' + value[3] + '</span>';
        else  return mapData.closeText;
            // return 'ZAMKNIĘTE';
        // return 'ZAVŘENO';
        // return 'ZÁRVA';
    }

    let callback;

    window.eqfeed_callback = function (results) {
        for (var i = 0; i < results.features.length; i++) {
            var coords = results.features[i].geometry.coordinates;
            var latLng = new google.maps.LatLng(coords[1], coords[0]);
            var marker = new google.maps.Marker({
                icon: 'assets/img/ic_poi3.png',
                position: latLng,
                // map: map,
                name: results.features[i].properties.name,
                // address: results.features[i].properties.city + ', ' + results.features[i].properties.street,
                address: results.features[i].properties.street + ', ' + results.features[i].properties.city,
                phone: results.features[i].properties.phone,
                email: results.features[i].properties.email,
                monfri: results.features[i].properties.monfri,
                sat: results.features[i].properties.sat,
                sun: results.features[i].properties.sun,
                cat: results.features[i].properties.cat,
                animation: google.maps.Animation.DROP
            });

            var content = '<div class="poi">' +
                '<p class="poi__firststop"></p>' +
                '<p class="poi__head">' + marker.name + '</p>' +
                '<p class="poi__addr">' + marker.address + '</p>' +
                // '<p style="padding-top:1rem"><strong>' + isLinkExpiryDateWithinRange(marker.monfri, marker.sat) + '</strong></p>' +
                '<p style="padding-top:1rem;margin-bottom:0"><strong>' + mapData.openText + '</strong>' +
                '<table class="unstriped" style="width:auto;border:0"><tbody style="border:0"><tr style="border:0"><td style="padding: 0 1rem 0.3rem 0;font-size:95%">' + mapData.pnptText + '</td><td style="padding: 0 1rem 0.3rem 0;font-size:95%">' + marker.monfri + '</td></tr>' +
                '<tr style="border:0"><td style="padding: 0 1rem 0.3rem 0;font-size:95%">' + mapData.satText + '</td><td style="padding: 0 1rem 0.3rem 0;font-size:95%">' + marker.sat + '</td></tr>' +
                '<tr style="border:0"><td style="padding: 0 1rem 0.3rem 0;font-size:95%">' + mapData.sunText + '</td><td style="padding: 0 1rem 0.3rem 0;font-size:95%">' + marker.sun + '</td></tr></tbody></table>' +
                '<p><a class="cta_showaddress" data-street="' + results.features[i].properties.street + '">' + mapData.routeText +  '</a></p>' +
                // '<p><a class="cta_showoffert" id="show-offer" m-name="' + marker.name + '"' + '">Sprawdź oferty pracy</a></p>' +
                "<a href=\"#\" data-tab-for=\"offer\" class=\"cta bg-white show-offer\" id=\"show-offer\" m-name=\""
                + marker.name +
                "\" m-adres=\""
                + marker.address +
                "\" m-tel=\""
                + marker.phone +
                "\" m-email=\""
                + marker.email +
                "\"data-m-cat=\""
                + marker.cat +
                // "\">ZOBACZ OFERTĘ</a>"
                "\">"
                + mapData.jobOffer +
                "</a>"
            // '<div class="poi">' + '<p class="poi__firststop"></p>' + '<p class="poi__head">' + marker.name + '</p>' + '<p class="poi__addr">' + marker.address + '</p>' + '<p style="padding-top:1rem"><strong>' + isLinkExpiryDateWithinRange(marker.monfri, marker.sat) + '</strong></p>' + '<p><a class="cta_showaddress" data-street="' + results.features[i].properties.street + '">Wyznacz trasę</a></p>' +
            // '<p><a class="cta_showaddress" data-street="' + results.features[i].properties.street + '">Vypočtěte trasu</a></p>' +
            // '<a class="cta_phone" data-phone="' + marker.phone + '">Zadzwoń</a><a href="mailto:' + marker.email + '" class="cta_visit" target="_blank">Napisz do nas</a>' +
            // '<a class="cta_phone" data-phone="' + marker.phone + '">Telefon</a><a href="mailto:' + marker.email + '" class="cta_visit" target="_blank">Poslat Email</a>' +
            // '<a class="cta_phone" data-phone="' + marker.phone + '">Hívás</a><a href="mailto:' + marker.email + '" class="cta_visit" target="_blank">Írj nekünk</a>' +
            '</div>';

            var infowindow = new google.maps.InfoWindow();

            var directionsService = new google.maps.DirectionsService();
            var directionsDisplay = new google.maps.DirectionsRenderer();

            marker.setVisible(false);

            if (marker.cat !== undefined) {
                if ((document.getElementById('checkbox-mechanic').checked) && (marker.cat.indexOf(mapData.mechanikText) > -1)) {
                    marker.setVisible(true);
                }
                if ((document.getElementById('checkbox-vulcanizer').checked) && (marker.cat.indexOf(mapData.wulkanizatorText) > -1)) {
                    marker.setVisible(true);
                }
                if ((document.getElementById('checkbox-assistant').checked) && (marker.cat.indexOf(mapData.doradcaText) > -1)) {
                    marker.setVisible(true);
                }
            }

            if (marker.getVisible()) {
                markers.push(marker);
            }


            google.maps.event.addListener(marker, 'click', function (marker, content, infowindow) {
                return function () {
                    infowindow.setContent(content);
                    infowindow.open(map, marker);
                    // google.maps.event.addListener(map, 'mousemove', function () {
                    //     infowindow.close();
                    // });
                    

                    setTimeout(function () {
                        $(".cta_phone").click(function () {
                            swal({
                                html: "<a href='tel:" + this.dataset.phone + "' style='font-size:2rem'>" + this.dataset.phone + "</a>",
                                showConfirmButton: false,
                                showCloseButton: true
                            });
                        });
                        $(".cta_showaddress").click(function () {

                            function showPosition(position) {

                                directionsService.route({
                                    origin: position.coords.latitude + ',' + position.coords.longitude,
                                    destination: marker.address,
                                    travelMode: 'DRIVING'
                                }, function (response, status) {
                                    if (status === 'OK') {
                                        directionsDisplay.setDirections(response);

                                        directionsDisplay.setMap(map);
                                    } else {
                                        window.alert('Directions request failed due to ' + status);
                                    }
                                });
                            }

                            var $ua = window.navigator.userAgent.toLowerCase();

                            if ($ua.indexOf('iphone') > -1 || $ua.indexOf('ipad') != -1 || $ua.indexOf('ipod') != -1 || $ua.indexOf('android') != -1 || $ua.indexOf('playbook') != -1) {
                                window.location = 'http://maps.apple.com/?saddr=My+Location&daddr=' + marker.address;
                            } else {
                                navigator.geolocation.getCurrentPosition(showPosition);
                            }
                        });
                    }, 50);
                };
            }(marker, content, infowindow));

            google.maps.event.addListener(marker, 'mouseover', (function (marker, content, infowindow) {
                return function () {
                    infowindow.setContent(content);
                    infowindow.open(map, marker);
                    // google.maps.event.addListener(map, 'mousemove', function () {
                    //     infowindow.close();
                    // });
                    $(document).on('click', '.poi', function(event){
                        infowindow.close();
                    });

                    setTimeout(function () {
                        $(".cta_phone").click(function () {
                            swal({
                                html: "<a href='tel:" + this.dataset.phone + "' style='font-size:2rem'>" + this.dataset.phone + "</a>",
                                showConfirmButton: false,
                                showCloseButton: true
                            });
                        });
                        $(".cta_showaddress").click(function () {

                            function showPosition(position) {

                                directionsService.route({
                                    origin: position.coords.latitude + ',' + position.coords.longitude,
                                    destination: marker.address,
                                    travelMode: 'DRIVING'
                                }, function (response, status) {
                                    if (status === 'OK') {
                                        directionsDisplay.setDirections(response);

                                        directionsDisplay.setMap(map);
                                    } else {
                                        window.alert('Directions request failed due to ' + status);
                                    }
                                });
                            }

                            var $ua = window.navigator.userAgent.toLowerCase();

                            if (($ua.indexOf('iphone') > -1)
                                || ($ua.indexOf('ipad') != -1)
                                || ($ua.indexOf('ipod') != -1)
                                || ($ua.indexOf('android') != -1)
                                || ($ua.indexOf('playbook') != -1)) {
                                window.location = 'http://maps.apple.com/?saddr=My+Location&daddr=' + marker.address;
                            } else {
                                navigator.geolocation.getCurrentPosition(showPosition);
                            }

                        });

                        $(".cta_showoffert").click(function () {
                            // $('.search-results-section').fadeIn();
                        });

                        $('.show-offer').on("click", showOffer);

                    }, 50);

                };
            })(marker, content, infowindow));

            callback = 'end';
        }

        all_markers = markers;
        markerCluster = new MarkerClusterer(map, markers, {imagePath: 'assets/img/m'});

    };

    function showMap() {
        if (callback === 'end') {
            $("#map").fadeTo("slow", 1);

            function getRequests() {
                var s1 = location.search.substring(1, location.search.length).split('&'),
                    r = {},
                    s2,
                    i;
                for (i = 0; i < s1.length; i += 1) {
                    s2 = s1[i].split('=');
                    r[decodeURIComponent(s2[0]).toLowerCase()] = decodeURIComponent(s2[1]);
                }
                return r;
            }

            var QueryString = getRequests();

            if (zurla === true && typeof QueryString["q"] !== 'undefined') {
                var input = document.getElementById('searchinput');
                input.value = QueryString["q"];
                $('#searchbutton').trigger("click");
                zurla = false;
            }

            $('#map').find('.gmnoprint > div').css('background', '#ed1c24');

            showVisibleMarkers(map);
        } else {
            setTimeout(showMap, 100);
        }
    }

    function searchResultsSectionVisibility() {
       if (callback === 'end') {
           // console.log('searchResultsSectionVisibility');
           if (sessionStorage.firstVisit) {
               if (count === 0) searchResultsSection.hide();
               else {
                   searchResultsSection.show();
                   if ($('#pushpois div.grid-x').length !== $('#pushpois div.grid-x:visible').length) {
                       $('#show-more-offers').show();
                   }
                   if ($('#pushpois div.grid-x').length == $('#pushpois div.grid-x:visible').length) {
                       $('#show-more-offers').hide();
                   }
               }
           } else sessionStorage.setItem("firstVisit", true);
       } else {
           setTimeout( searchResultsSectionVisibility, 100);
       }
    }

    google.maps.event.addListener(map, 'idle', function () {
        // console.log(markers.length);
        // console.log(callback);
        showMap();
        searchResultsSectionVisibility();
    });
}

const markersDataLang = {
    pl: {
        closeText: 'ZAMKNIĘTE',
        openText: 'OTWARTE DO',
        routeText: 'Wyznacz trasę',
        phoneText: 'Zadzwoń',
        emailText: 'Napisz do nas',
        jobOffer: 'ZOBACZ OFERTĘ',
        mechanikText: 'Mechanik',
        wulkanizatorText: 'Wulkanizator',
        doradcaText: 'Doradca Klienta'

    },
    cz: {
        closeText: 'ZAVŘENO',
        openText: 'OTEVŘENO DO',
        routeText: 'Vypočtěte trasu',
        phoneText: 'Telefon',
        emailText: 'Poslat Email',
        jobOffer: 'ZOBRAZ NABÍDKY',
        mechanikText: 'Mechanik',
        wulkanizatorText: 'Montér pneumatik',
        doradcaText: 'Zákaznický servis'
    },
    hu: {
        closeText: 'ZÁRVA',
        openText: 'NYITOTT',
        routeText: 'Számolja útvonal',
        phoneText: 'Hívás',
        emailText: 'Írj nekünk',
        jobOffer: 'JELENTKEZEM',
        mechanikText: 'Autószerelő',
        wulkanizatorText: 'Gumiszerelő',
        doradcaText: 'Vevőszolgálati tanácsadó'
    }
};

let markerData;

if ( checkLang() === 'pl') {
    markerData = markersDataLang.pl;
}

if ( checkLang() === 'cz') {
    markerData = markersDataLang.cz;
}

if ( checkLang() === 'hu') {
    markerData = markersDataLang.hu;
}


function showVisibleMarkers(map) {

    var bounds = map.getBounds();
    // console.log('showVisibleMarkers start, wszystkie markery:' + markers.length);
    count = 0;
    $('#pushpois').html('');

    for (var i = 0; i < markers.length; i++) {
        var marker = markers[i];

        if (bounds.contains(marker.getPosition()) === true) {

            let markerArr;
            let test = `<ul>`;

            if (marker.cat !== undefined) {
                if ((document.getElementById('checkbox-mechanic').checked) && (marker.cat.indexOf(markerData.mechanikText) > -1)) {
                    marker.setVisible(true);
                }
                if ((document.getElementById('checkbox-vulcanizer').checked) && (marker.cat.indexOf(markerData.wulkanizatorText) > -1)) {
                    marker.setVisible(true);

                }
                if ((document.getElementById('checkbox-assistant').checked) && (marker.cat.indexOf(markerData.doradcaText) > -1)) {
                    marker.setVisible(true);
                }

                markerArr = marker.cat.split("; ");
                for (let i = 0; i < markerArr.length; i++) {
                    let li = `<li>${markerArr[i]}</li>`;
                    test = test + li;
                }
                test = test + `</ul>`;
                count++;
            }

            var poi_phone = '';
            if (marker.phone !== null) poi_phone = marker.phone;

            var pushhtml =
                "<div class=\"grid-x border-bottom\">\n" +
                "                            <div class=\"cell medium-8 large-6\">\n" +
                "                                <div class=\"cat\">"
                // + marker.cat
                + test
                +
                " </div>\n" +
                "                            </div>\n" +
                "                            <div class=\"cell medium-8 large-6\">\n" +
                "                                <div class=\"adres\">"
                + marker.name +
                " "
                + marker.address +
                "</div>\n" +
                "                            </div>\n" +
                "                            <div class=\"cell medium-16 large-4 text-center medium-text-right\">\n" +
                "                                <a href=\"#\" class=\"cta bg-white show-offer\" data-tab-for=\"offer\" id=\"show-offer\" m-name=\""
                + marker.name +
                "\" m-adres=\""
                + marker.address +
                "\" m-tel=\""
                + poi_phone +
                "\" m-email=\""
                + marker.email +
                "\"data-m-cat=\""
                + marker.cat +
                "\">" +
                markerData.jobOffer
                + "</a> </div>";

            if (marker.visible === true) {
                $('#pushpois').prepend(pushhtml);
                if ($('#pushpois div.grid-x').length !== $('#pushpois div.grid-x:visible').length) {
                    $('#show-more-offers').show();
                }
                if ($('#pushpois div.grid-x').length == $('#pushpois div.grid-x:visible').length) {
                    $('#show-more-offers').hide();
                }
            }

            // console.log('liczba ofert: ' + count);
            $('#info').html(count);

        }
        else {
            // count = 0;
            // infoPanel.hide();
            $('#info').html(count);
        }
    }

    if (markers.length === 0) {
        count = 0;
        $('#info').html(count);
    }
}

$('#useMyLocation').click(function () {
    initMap();
    return false;
});

window.initMap = initMap;

// sekcje

const searchSection = $(".search-section");
const mapSection = $(".map-section");
const searchResultsSection = $(".search-results-section");
const videoSection = $(".video-section");
const offerSection = $(".offer-section");
const benefitsSection = $(".benefits-section");
const offerFormSection = $(".offer-form-section");
const sendConfirmSection = $(".send-confirm-section");

// przyciski

const locButton = $('#loc-button');
const showMoreOffersButton = $('#show-more-offers');
const backToSearchButton = $('.back-to-search');
const toCvFormButton = $('.to-cv-form');
const addCvButton = $('#add-cv');
const sendCvButton = $('#send-cv');

// sectionStorage
sessionStorage.removeItem("firstVisit");

// formularz

const offerForm = $('#offer-form');

locButton.click(function () {
    map = null;
    markers = [];
    all_markers = [];
    markerCluster = null;
   setTimeout(function (){
       window.initMap(map);
       // searchResultsSection.fadeIn(500);
   }, 500)
    // return false;
});

$(document).on('click','#show-offer', showOffer);

function showOffer(e) {

    const markerName = $(".m-name");
    const markerAdres = $(".m-adres");
    const markerTel = $(".m-tel");
    const markerEmail = $(".m-email");
    const markerEmailInput = $(".m-email-input");

    var valName = $(this).attr('m-name');
    markerName.html(valName);

    var valAdres = $(this).attr('m-adres');
    markerAdres.html(valAdres);

    var valTel = $(this).attr('m-tel');
    markerTel.html(valTel);

    var valEmail = $(this).attr('m-email');
    markerEmail.html(valEmail);

    markerEmailInput.val(valEmail);

    document.querySelector('.mechanic-offer').classList.add('hide');
    document.querySelector('.vulcanizer-offer').classList.add('hide');
    document.querySelector('.assistant-offer').classList.add('hide');

    const offset = document.querySelector('section.header').offsetHeight + 100;

    scrollTopWithOffset(offset);
}

showMoreOffersButton.on("click", function(e) {
    e.preventDefault();
    $('#pushpois div.grid-x:hidden').slice(0, 2).css("display", "flex").hide().slideDown(1000);
    // showMoreOffersButton.hide();
    if ($('#pushpois div.grid-x').length == $('#pushpois div.grid-x:visible').length) {
        $('#show-more-offers').hide();
    }
});

backToSearchButton.on("click", function () {
    goToTop();
    // .removeClass('offer-on').fadeIn(100);
});

toCvFormButton.on("click", function () {
    // goToTop();
    offerSection.fadeOut(100);
    offerFormSection.fadeIn(100);
    benefitsSection.removeClass('offer-on').fadeOut(100);

    const markerCat = $(".m-cat");
    const markerCatInput = $(".m-cat-input");

    if ($(this).attr('class').indexOf('mechanic') > -1) {
        markerCat.html(markerData.mechanikText);
        markerCatInput.val(markerData.mechanikText);
    }

    if ($(this).attr('class').indexOf('vulcanizer') > -1) {
        markerCat.html(markerData.wulkanizatorText);
        markerCatInput.val(markerData.wulkanizatorText);
    }

    if ($(this).attr('class').indexOf('assistant') > -1) {
        markerCat.html(markerData.doradcaText);
        markerCatInput.val(markerData.doradcaText);
    }

    const offset = document.querySelector('section.header').offsetHeight + 100;

    scrollTopWithOffset(offset);
});

addCvButton.on("click", function () {
    offerForm.find('[type="file"]').trigger('click');
});

sendCvButton.on("click", function () {
    const expAreaVal = document.querySelector('#experience').value;

    if (expAreaVal) {
        document.querySelector('#file-upload').required = false;
        // console.log(offerForm.find('[type="submit"]'));
        offerForm.find('[type="submit"]').trigger('click');
    } else {
        offerForm.find('[type="submit"]').trigger('click');
        // console.log('nie wysyłamy');
    }
});

//tymczasowe
const alertMessageData = {
    pl: 'formularz wypełniony poprawnie, ale funkcja wysyłania wiadomości email nie została jeszcze uruchomiona',
    hu: 'A jelentkezési lap megfelelően kitöltésre került, de az e-mail visszajelzés nem került beállításra',
    cz: 'formularz wypełniony poprawnie, ale funkcja wysyłania wiadomości email nie została jeszcze uruchomiona'
};

let alertMessage;

if ( checkLang() === 'pl') {
    alertMessage = alertMessageData.pl;
}

if ( checkLang() === 'cz') {
    alertMessage = alertMessageData.cz;
}

if ( checkLang() === 'hu') {
    alertMessage = alertMessageData.hu;
}




offerForm.on('submit', function (e) {
    e.preventDefault();

    $.ajax({
        type: 'post',
        url: 'myPageName.php',
        data: offerForm.serialize(),
        success: function () {
            goToTop();
            document.querySelector("#toConfirm").click();
            offerForm[0].reset();
            document.querySelector('.file-upload_result').innerHTML = '';
        },
        error: function () {
            // window.alert(alertMessage);
            // tymczasowo
            goToTop();
            document.querySelector("#toConfirm").click();
            offerForm[0].reset();
            document.querySelector('.file-upload_result').innerHTML = '';
        }
    });

});

// map checkbox

const mapCheckboxs = document.querySelectorAll('.map-checkbox');

mapCheckboxs.forEach(mapCheckboxs => mapCheckboxs.addEventListener('change', afterCheckboxChange));

function afterCheckboxChange() {
    document.querySelector('.mechanic-offer').classList.add('hide');
    document.querySelector('.vulcanizer-offer').classList.add('hide');
    document.querySelector('.assistant-offer').classList.add('hide');

    map = null;
    markers = [];
    all_markers = [];
    markerCluster = null;
    initMap();
}

// scrollToTop

function goToTop() {
    $("html, body").animate({scrollTop: 0}, "500");
}

// scrollWithOffset

function scrollTopWithOffset(offset) {
    $("html, body").animate(
        {
            scrollTop: offset
        }, 500);
}

//File upload message receipt

var FileUpload = function (el) {
    this.noValue = '';
    this.$container = $(el);
    this.$input = this.$container.find('input[type=file]');
    this.$result = this.$container.find('.file-upload_result').html(this.noValue);
    this.getValue();
};

FileUpload.prototype.getValue = function () {
    var self = this;
    this.$input.on('change', function () {
        var valueArray = $(this).val().split('\\'),
            value = valueArray[valueArray.length - 1];
        if (value.length === 0) {
            self.$result.html(self.noValue);
        } else {
            self.$result.html(value);
        }
    });
};

new FileUpload('#add-cv-box');

// Historia

window.addEventListener('popstate', function (popstateEvent) {
    console.log(popstateEvent.state);
});

var tabs = document.querySelectorAll("a[data-tab-for]");
var contents = document.querySelectorAll(".content");

// tabs.forEach(tab => tab.addEventListener('click', tabClicked));
$(document).on('click', 'a[data-tab-for]', tabClicked);
window.onpopstate = checkState;

history.replaceState({
    tabForId: "main"
}, null, '#main');

function showContent(id, cat) {
    const loader = document.querySelector('.loader-container');

    contents.forEach(content => {

        if (content.classList.contains(id)) {
            loader.classList.remove('hiden');
            content.classList.remove('hide');

            if ((id === 'offer') && cat) {
                if ((cat.indexOf(markerData.mechanikText) > -1) && (document.getElementById('checkbox-mechanic').checked)) {
                    document.querySelector('.mechanic-offer').classList.remove('hide');
                }

                if ((cat.indexOf(markerData.wulkanizatorText) > -1) && (document.getElementById('checkbox-vulcanizer').checked)) {
                    document.querySelector('.vulcanizer-offer').classList.remove('hide');
                }

                if ((cat.indexOf(markerData.doradcaText) > -1) && (document.getElementById('checkbox-assistant').checked)) {
                    document.querySelector('.assistant-offer').classList.remove('hide');
                }
            }

            if (id === 'offer') {
                benefitsSection.addClass('offer-on');
            } else {
                benefitsSection.removeClass('offer-on');
            }
        }
        else content.classList.add('hide');
        if ((content.classList.contains(id))) content.style.display="block"


    });
    tabs.forEach(tab => {
        if (tab.dataset.tabFor === id) tab.classList.add("active");
        else tab.classList.remove("active");
    });

    var tabsTitles = document.querySelectorAll(".tabs-title:not([class*='hide'])");
    tabsTitles[0].click();

    if (tabsTitles.length === 1) document.querySelector('.tabs-menu').style.display = 'none';
    else document.querySelector('.tabs-menu').style.display = 'block';

    setTimeout(function () {
        loader.classList.add('hiden');
    }, 500)
}

function tabClicked(e) {
    var contentId = e.target.dataset.tabFor;
    var catID = e.target.dataset.mCat;
    e.preventDefault();
    showContent(contentId, catID);
    history.pushState({
        tabForId: contentId
    }, null, '#'+contentId);
}

function checkState(e) {
    // page reload
    if(e.state) {
        // console.log(e.state.tabForId);
        showContent(e.state.tabForId);
    }
}
